import { Node } from "prosemirror-model";

export function toDeltaPos(doc: Node, pos: number) {
  let opened = 0;
  for (let i = 0, off = 0; i < doc.childCount; i += 1) {
    if (off < pos) opened += 1;
    off += doc.child(i).nodeSize;
    if (off >= pos) break;
  }
  return pos - opened;
}

export function fromDeltaPos(doc: Node, pos: number) {
  for (let i = 0, start = 0; i < doc.childCount; i += 1) {
    const child = doc.child(i);
    const size = child.content.size;
    if (start + size >= pos) return pos + i + 1;
    start += size + 1;
  }
  return doc.content.size;
}
